import React, { useEffect } from 'react';
import './HandpaintingSlider.css'; // Import the CSS file

// Your image imports (as provided in your prompt)
const slider1 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(1).jpg";
const slider2 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(2).jpg";
const slider3 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(3).jpg";
const slider4 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(4).jpg";
const slider5 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(5).jpg";
const slider6 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(6).jpg";
const slider7 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(7).jpg";
const slider8 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(8).jpg";
const slider9 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(9).jpg";
const slider10 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(10).jpg";
const slider11 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(11).jpg";
const slider12 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(12).jpg";
const slider13 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(13).jpg";
const slider14 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(14).jpg";
const slider15 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(15).jpg";
const slider16 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(16).jpg";
const slider17 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(17).jpg";
const slider18 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(18).jpg";
const slider19 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(19).jpg";
const slider20 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(20).jpg";
const slider21 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(21).jpg";
const slider22 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(22).jpg";
const slider23 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(23).jpg";
const slider24 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(24).jpg";
const slider25 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(25).jpg";
const slider26 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(26).jpg";
const slider27 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(27).jpg";
const slider28 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(28).jpg";
const slider29 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(29).jpg";
const slider30 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(30).jpg";
const slider31 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(31).jpg";
const slider33 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(33).jpg";
const slider34 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(34).jpg";
const slider35 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(35).jpg";
const slider37 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(37).jpg";
const slider38 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(38).jpg";
const slider39 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(39).jpg";
const slider40 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(40).jpg";
const slider41 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(41).jpg";
const slider42 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(42).jpg";
const slider43 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(43).jpg";
const slider44 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(44).jpg";
const slider45 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(45).jpg";
const slider46 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(46).jpg";
const slider47 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ImagesHandpaintingSlider/ASW_+(47).jpg";



const HandpaintingSlider = () => {
  const images = [
    slider1, slider2, slider3, slider4, slider5, slider6, slider7, slider8,
    slider9, slider10, slider11, slider12, slider13, slider14, slider15, slider16,
    slider17, slider18, slider19, slider20, slider21, slider22, slider23, slider24,
    slider25, slider26, slider27, slider28, slider29, slider30, slider31,
    slider33, slider34, slider35, slider37, slider38, slider39, slider40,
    slider41, slider42, slider43, slider44, slider45, slider46, slider47
  ];
    useEffect(() => {
    // Force prevent scroll globally
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';

    // Prevent pinch or side swipe on mobile
    document.body.style.touchAction = 'pan-y';

    return () => {
      document.body.style.overflowX = '';
      document.documentElement.style.overflowX = '';
      document.body.style.touchAction = '';
    };
  }, []);

  // Duplicate the list for looping
  // This is crucial for the -50% translation to work seamlessly
  const loopImages = [...images, ...images];

  return (
    <div className="slider-outer-container">
      <h2 className="slider-title">
        Our Artists and Art Shows
      </h2>

      {/* The main slider viewport */}
      <div className="slider-container">
        {/* The track that will hold all images and be animated */}
       <div
  className="slider-track"
  onTouchStart={(e) => {
    e.currentTarget.style.animationPlayState = "paused";
  }}
  onTouchEnd={(e) => {
    e.currentTarget.style.animationPlayState = "running";
  }}
>
  {loopImages.map((img, index) => (
    <img
      key={index}
      src={img}
      alt={`slide-${index}`}
      className="slide-image"
    />
  ))}
</div>

      </div>
    </div>
  );
};

export default HandpaintingSlider;